// Extra translations for landing sections added in Phase 1 enhancement.
// Imported separately and merged with main translations.

export const landingExtras = {
  en: {
    live_counter: {
      template: "{n} backpackers optimized their CV today",
    },
    new_stats: {
      callbacks: { n: "3x", t: "more callbacks vs a non-optimized CV" },
      hired: { n: "7 days", t: "average time to land a job with AussieCV" },
      points: { n: "+38", t: "average ATS score boost" },
      pay: { n: "+$8/h", t: "average pay increase from better job match" },
    },
    testimonials: {
      title: "Backpackers who got hired",
      sub: "Real stories from the AussieCV community",
      rating: "4.8 out of 5 — based on 1,847 backpackers",
    },
    hired_at: {
      title: "Our users got hired at",
      sub: "Top Australian employers",
    },
    final_cta: {
      title: "Ready to land your job in Australia?",
      sub: "60 seconds. Optimized for Australia. Get hired faster.",
      btn: "Optimize my CV — Free",
      note: "Takes 60 seconds. Works on mobile.",
    },
    before_after: {
      title: "What we fix in 60 seconds",
      sub: "From rejected by ATS to ready to apply",
      before_label: "Before — generic / non-AU CV",
      after_label: "After — AussieCV optimized",
      before_score: "ATS 52 · REJECTED",
      after_score: "ATS 92 · ATS-READY",
      annos: {
        photo: "Photo not allowed in AU",
        no_visa: "Visa missing",
        bad_dates: "Zero duration",
        french_terms: "French terms — ATS blind",
        no_keywords: "No keywords from job ad",
        visa_ok: "Visa upfront",
        au_terms: "Australian terms",
        good_dates: "Clear timeline",
        keywords_ok: "Job-matched keywords",
        local_ok: "Local + immediate",
      },
    },
  },
  fr: {
    live_counter: { template: "{n} backpackers ont optimisé leur CV aujourd'hui" },
    new_stats: {
      callbacks: { n: "3x", t: "plus de retours qu'avec un CV non optimisé" },
      hired: { n: "7 jours", t: "temps moyen pour décrocher un job avec AussieCV" },
      points: { n: "+38", t: "points ATS gagnés en moyenne" },
      pay: { n: "+$8/h", t: "augmentation moyenne de salaire grâce au meilleur match" },
    },
    testimonials: {
      title: "Des backpackers qui ont décroché leur job",
      sub: "Histoires réelles de la communauté AussieCV",
      rating: "4.8 sur 5 — basé sur 1,847 backpackers",
    },
    hired_at: {
      title: "Nos utilisateurs ont été recrutés chez",
      sub: "Les plus gros employeurs australiens",
    },
    final_cta: {
      title: "Prêt à décrocher ton job en Australie ?",
      sub: "60 secondes. Optimisé pour l'Australie. Décroche ton job plus vite.",
      btn: "Optimiser mon CV — Gratuit",
      note: "Prend 60 secondes. Marche sur mobile.",
    },
    before_after: {
      title: "Ce qu'on corrige en 60 secondes",
      sub: "De rejeté par l'ATS à prêt à postuler",
      before_label: "Avant — CV générique / non-AU",
      after_label: "Après — optimisé par AussieCV",
      before_score: "ATS 52 · REJETÉ",
      after_score: "ATS 92 · ATS-READY",
      annos: {
        photo: "Photo interdite en AU",
        no_visa: "Visa manquant",
        bad_dates: "Durée zéro",
        french_terms: "Termes français — ATS aveugle",
        no_keywords: "Pas de mots-clés de l'annonce",
        visa_ok: "Visa en haut",
        au_terms: "Termes australiens",
        good_dates: "Dates claires",
        keywords_ok: "Mots-clés matchés",
        local_ok: "Local + dispo",
      },
    },
  },
  de: {
    live_counter: { template: "{n} Backpacker haben heute ihren CV optimiert" },
    new_stats: {
      callbacks: { n: "3x", t: "mehr Rückrufe als mit einem nicht-optimierten CV" },
      hired: { n: "7 Tage", t: "Durchschnittszeit für einen Job mit AussieCV" },
      points: { n: "+38", t: "durchschnittlicher ATS-Score-Boost" },
      pay: { n: "+$8/h", t: "durchschnittliche Gehaltssteigerung" },
    },
    testimonials: {
      title: "Backpacker, die eingestellt wurden",
      sub: "Echte Geschichten aus der AussieCV-Community",
      rating: "4.8 von 5 — basierend auf 1.847 Backpackern",
    },
    hired_at: {
      title: "Unsere Nutzer wurden eingestellt bei",
      sub: "Top australische Arbeitgeber",
    },
    final_cta: {
      title: "Bereit, deinen Job in Australien zu finden?",
      sub: "60 Sekunden. Für Australien optimiert. Schneller einen Job finden.",
      btn: "CV optimieren — Gratis",
      note: "Dauert 60 Sekunden. Funktioniert mobil.",
    },
    before_after: {
      title: "Was wir in 60 Sekunden korrigieren",
      sub: "Von ATS abgelehnt zu bewerbungsbereit",
      before_label: "Vorher — generischer / Nicht-AU-CV",
      after_label: "Nachher — von AussieCV optimiert",
      before_score: "ATS 52 · ABGELEHNT",
      after_score: "ATS 92 · ATS-READY",
      annos: {
        photo: "Foto in AU nicht erlaubt",
        no_visa: "Visum fehlt",
        bad_dates: "Null Dauer",
        french_terms: "Falsche Begriffe — ATS blind",
        no_keywords: "Keine Keywords aus der Anzeige",
        visa_ok: "Visum sichtbar oben",
        au_terms: "Australische Begriffe",
        good_dates: "Klare Daten",
        keywords_ok: "Passende Keywords",
        local_ok: "Lokal + sofort",
      },
    },
  },
  it: {
    live_counter: { template: "{n} backpacker hanno ottimizzato il loro CV oggi" },
    new_stats: {
      callbacks: { n: "3x", t: "più richiami rispetto a un CV non ottimizzato" },
      hired: { n: "7 giorni", t: "tempo medio per trovare lavoro con AussieCV" },
      points: { n: "+38", t: "punteggio ATS medio guadagnato" },
      pay: { n: "+$8/h", t: "aumento salariale medio" },
    },
    testimonials: {
      title: "Backpacker che hanno trovato lavoro",
      sub: "Storie reali dalla community AussieCV",
      rating: "4.8 su 5 — basato su 1.847 backpacker",
    },
    hired_at: {
      title: "I nostri utenti sono stati assunti da",
      sub: "I migliori datori di lavoro australiani",
    },
    final_cta: {
      title: "Pronto a trovare il tuo lavoro in Australia?",
      sub: "60 secondi. Ottimizzato per l'Australia. Trova lavoro più velocemente.",
      btn: "Ottimizza il mio CV — Gratis",
      note: "Ci vogliono 60 secondi. Funziona su mobile.",
    },
    before_after: {
      title: "Cosa correggiamo in 60 secondi",
      sub: "Da rifiutato dall'ATS a pronto per candidarti",
      before_label: "Prima — CV generico / non-AU",
      after_label: "Dopo — ottimizzato da AussieCV",
      before_score: "ATS 52 · RIFIUTATO",
      after_score: "ATS 92 · ATS-READY",
      annos: {
        photo: "Foto non permessa in AU",
        no_visa: "Visto mancante",
        bad_dates: "Durata zero",
        french_terms: "Termini sbagliati — ATS cieco",
        no_keywords: "Nessuna keyword dall'annuncio",
        visa_ok: "Visto in alto",
        au_terms: "Termini australiani",
        good_dates: "Date chiare",
        keywords_ok: "Keyword corrispondenti",
        local_ok: "Locale + subito",
      },
    },
  },
  es: {
    live_counter: { template: "{n} backpackers optimizaron su CV hoy" },
    new_stats: {
      callbacks: { n: "3x", t: "más respuestas que con un CV no optimizado" },
      hired: { n: "7 días", t: "tiempo medio para encontrar trabajo con AussieCV" },
      points: { n: "+38", t: "puntos ATS ganados en promedio" },
      pay: { n: "+$8/h", t: "aumento salarial promedio" },
    },
    testimonials: {
      title: "Backpackers que consiguieron trabajo",
      sub: "Historias reales de la comunidad AussieCV",
      rating: "4.8 sobre 5 — basado en 1,847 backpackers",
    },
    hired_at: {
      title: "Nuestros usuarios fueron contratados en",
      sub: "Los principales empleadores australianos",
    },
    final_cta: {
      title: "¿Listo para conseguir tu trabajo en Australia?",
      sub: "60 segundos. Optimizado para Australia. Consigue trabajo más rápido.",
      btn: "Optimizar mi CV — Gratis",
      note: "Tarda 60 segundos. Funciona en móvil.",
    },
    before_after: {
      title: "Lo que arreglamos en 60 segundos",
      sub: "De rechazado por el ATS a listo para postular",
      before_label: "Antes — CV genérico / no-AU",
      after_label: "Después — optimizado por AussieCV",
      before_score: "ATS 52 · RECHAZADO",
      after_score: "ATS 92 · ATS-READY",
      annos: {
        photo: "Foto no permitida en AU",
        no_visa: "Visa faltante",
        bad_dates: "Duración cero",
        french_terms: "Términos incorrectos — ATS ciego",
        no_keywords: "Sin palabras clave del anuncio",
        visa_ok: "Visa arriba",
        au_terms: "Términos australianos",
        good_dates: "Fechas claras",
        keywords_ok: "Palabras clave coincidentes",
        local_ok: "Local + inmediato",
      },
    },
  },
  pt: {
    live_counter: { template: "{n} backpackers otimizaram seu CV hoje" },
    new_stats: {
      callbacks: { n: "3x", t: "mais retornos que com um CV não otimizado" },
      hired: { n: "7 dias", t: "tempo médio para conseguir trabalho com AussieCV" },
      points: { n: "+38", t: "pontos ATS ganhos em média" },
      pay: { n: "+$8/h", t: "aumento salarial médio" },
    },
    testimonials: {
      title: "Backpackers que conseguiram trabalho",
      sub: "Histórias reais da comunidade AussieCV",
      rating: "4.8 de 5 — baseado em 1.847 backpackers",
    },
    hired_at: {
      title: "Os nossos utilizadores foram contratados em",
      sub: "Os melhores empregadores australianos",
    },
    final_cta: {
      title: "Pronto para conseguir o teu trabalho na Austrália?",
      sub: "60 segundos. Otimizado para a Austrália. Arranja emprego mais rápido.",
      btn: "Otimizar meu CV — Grátis",
      note: "Demora 60 segundos. Funciona no mobile.",
    },
    before_after: {
      title: "O que corrigimos em 60 segundos",
      sub: "De rejeitado pelo ATS a pronto para candidatar-te",
      before_label: "Antes — CV genérico / não-AU",
      after_label: "Depois — otimizado pelo AussieCV",
      before_score: "ATS 52 · REJEITADO",
      after_score: "ATS 92 · ATS-READY",
      annos: {
        photo: "Foto não permitida na AU",
        no_visa: "Visto em falta",
        bad_dates: "Duração zero",
        french_terms: "Termos errados — ATS cego",
        no_keywords: "Sem palavras-chave do anúncio",
        visa_ok: "Visto no topo",
        au_terms: "Termos australianos",
        good_dates: "Datas claras",
        keywords_ok: "Palavras-chave correspondentes",
        local_ok: "Local + imediato",
      },
    },
  },
};
